module.exports = __webpack_public_path__ + "img/location.2f0f5cf5.svg";